import { Injectable } from '@angular/core';
import { BaseService } from '../Base/BaseService';
import { HttpClient } from '@angular/common/http';
import { AuthService } from '../Interceptor/auth.service';
import { SessionStorageService } from '../sessionStorageService/session-storage.service';
import { FinalBeneficiaries } from 'src/app/Model/FInalBeneficiaries.model';
import { ResponseData } from 'src/app/Model/Base/Response';
import { FinalBeneficiariesAnswers } from 'src/app/Model/FinalBeneficiariesAnswers.model';

@Injectable({
  providedIn: 'root'
})
export class FinalBeneficiariesService extends BaseService{

  constructor(public http: HttpClient, public lsService: SessionStorageService, authService: AuthService) {
    super(http, lsService, authService);
    this.Component = "FinalBeneficiariesService";
  }

  public async PostFinalBeneficiarie(finalBeneficiaries: FinalBeneficiaries){
    let response: ResponseData;
    await this.PostData(finalBeneficiaries, "FinalBeneficiaries", "PostFinalBeneficiarie").then((res) => {
      response = res;
    });
    return response;
  }

  public async DeleteFinalBeneficiarie(finalBeneficiaries: FinalBeneficiaries){
    let response: ResponseData;
    await this.PostData(finalBeneficiaries, "FinalBeneficiaries", "DeleteBeneficiarie").then((res) => {
      response = res;
    });
    return response;
  }

  public async PostFinalBeneficiarieAnswer(answer: FinalBeneficiariesAnswers){
    let response: ResponseData;
    await this.PostData(answer, "FinalBeneficiaries", "postBeneficiariesAnswers").then((res) => {
      response = res;
    });
    return response;
  }
}
